/**
 * Coheres the value to a string. An empty string is returned for `undefined` and `null`,
 *
 * @example
 * stringifyValue('hello'); // 'hello'
 * stringifyValue(345); // '345'
 * stringifyValue(undefined); // ''
 * stringifyValue(null); // ''
 */
export function stringifyValue(value: string | number | undefined | null) {
  if (value === undefined || value === null) {
    return '';
  }

  if (typeof value === 'number') {
    return value.toString(10);
  }

  return value;
}
